
import Vue from 'vue';
import { FileDocument } from '@/model';
import { RouteNames } from '@/router/route-names';

export default Vue.extend({
  name: 'DocumentList',

  props: {
    documents: { type: Array as () => FileDocument[], default: () => [] },
    linkable: { type: Boolean, default: false },
  },

  data() {
    return {
      routeNames: RouteNames,
    };
  },

});
